import { ConfigMinMaxUser, RegisterUserErrorMessages, Roles } from "common";
import * as yup from "yup";
import { createEnterpriseUserSchema as schema } from "containers/CreateEnterpriseUser/CreateEnterpriseUser.type";

export interface ValidationResult {
  isValid: boolean;
  errors: Record<string, string>;
}

export async function validateForm<T extends yup.Maybe<yup.AnyObject>>(
  schema: yup.ObjectSchema<T>,
  data: T
): Promise<ValidationResult> {
  try {
    await schema.validate(data, { abortEarly: false });
    return { isValid: true, errors: {} };
  } catch (err: any) {
    const errors: Record<string, string> = {};
    if (err.inner && Array.isArray(err.inner)) {
      err.inner.forEach((error: any) => {
        if (error.path) errors[error.path] = error.message;
      });
    }
    return { isValid: false, errors };
  }
}

export const getTotalRecordsErrorMessage = (
  userRole: string,
  totalRecords: number
): string => {
  let errorMessage = "";

  switch (userRole) {
    case Roles.BUChecker:
    case Roles.BusinessApprover:
      if (totalRecords >= ConfigMinMaxUser.MaxUsers) {
        errorMessage = RegisterUserErrorMessages.Checker;
      }
      break;
    case Roles.BUMaker:
    case Roles.BusinessOwner:
      if (totalRecords >= ConfigMinMaxUser.MaxUsers) {
        errorMessage = RegisterUserErrorMessages.Maker;
      }
      break;
    case Roles.BUApprover:
      if (totalRecords >= ConfigMinMaxUser.MaxUsers) {
        errorMessage = RegisterUserErrorMessages.Approver;
      }
      break;
  }
  return errorMessage;
};

export const getAlertTitle = (errors: any): string => {
  return (
    errors?.data?.errors
      ?.map((err: any) => {
        if (err.code === "001.S01.409.07")
          return "Business Unit Code already exists.";

        return err.message;
      })
      ?.join(", ") ?? "Something went wrong!"
  );
};

export async function validateField(
  field: string,
  value: any,
  formData: any
): Promise<{ [key: string]: string | undefined }> {
  try {
    await schema.validateAt(field, {
      ...formData,
      [field]: value,
    });
    return { [field]: undefined };
  } catch (err: any) {
    if (err instanceof yup.ValidationError) {
      return { [field]: err.message };
    }
    return { [field]: undefined };
  }
}
